// @core/api/endpoints/workflow/sync_product_manifest.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SyncProductManifestRequest,
  SyncProductManifestResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Sync product manifest
 * Registers or updates a product's event catalog, node types, and pipeline templates. Fully idempotent — safe to call on every service startup. Triggers Kafka subscription refresh for event-driven pipelines.
 */
export async function SyncProductManifest(
  data: SyncProductManifestRequest,
  options?: RequestOptions
): Promise<SyncProductManifestResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/product-registry/sync`;
  const requestOptions = options;
  return client.post<SyncProductManifestResponse>(requestPath, data, requestOptions);
}
